import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../Component/eislogo.png";

import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaYoutube, FaWhatsapp } from "react-icons/fa";
import { MdPhone, MdEmail, MdMessage, MdClose } from "react-icons/md";
import { BsClock } from "react-icons/bs";
import { IoCall, IoSend } from "react-icons/io5";

const Footer = () => {
  // Chat State
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [chatMessages, setChatMessages] = useState([
    { id: 1, sender: "bot", text: "Hello! Welcome to Envision Support. How can I help you today?", time: "10:00 AM" }
  ]);

  const toggleChat = () => setIsChatOpen(!isChatOpen);

  const handleSendMessage = () => {
    if (!message.trim()) return;

    const userMessage = {
      id: chatMessages.length + 1,
      sender: "user",
      text: message,
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };

    setChatMessages([...chatMessages, userMessage]);
    setMessage("");

    setTimeout(() => {
      const botMessage = {
        id: chatMessages.length + 2,
        sender: "bot",
        text: "Thank you for your message! Our team will get back to you shortly.",
        time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      };
      setChatMessages((prev) => [...prev, botMessage]);
    }, 1000);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const services = [
    { name: "AI/ML Model development", path: "/aimlmodel" },
    { name: "NLP Solutions", path: "/nlp" },
    { name: "Data Engineering and Analytics", path: "/dataengineering" },
    { name: "Web Development", path: "/webdev" },
    { name: "ERP Platform Solutions", path: "/erp" },
    { name: "Custom AI Solutions", path: "/customai" },
    { name: "Engineering Design Solutions", path: "/engneeringdesignsolution" },
    { name: "Industrial Automation", path: "/industrialautomate" },
    { name: "Digital Factory", path: "/digitalfactory" },
    { name: "Digital Marketing Solution", path: "/dmspage" },
    { name: "Graphics Design Solution", path: "/gdspage" },
    { name: "Multimedia Solutions", path: "/ms" },
  ];

  // Split services into two equal columns
  const midPoint = Math.ceil(services.length / 2);
  const servicesCol1 = services.slice(0, midPoint);
  const servicesCol2 = services.slice(midPoint);

  const industryLinks = [
    { name: "Banking & Capital Markets", path: "/banking" },
    { name: "Healthcare & Life Sciences", path: "/healthsci" },
    { name: "High Tech", path: "/hitech" },
    { name: "Software & Digital Platforms", path: "/software" },
  ];

  const productsData = [
    { name: "Learning Management System", path: "/lmspage" },
    { name: "Digital Menu & POS", path: "/billingsys" },
    { name: "HRMS (Human Resource Management)", path: "/hrmspage" },
  ];

  const socialLinks = [
    { icon: FaFacebookF, link: "#" },
    { icon: FaTwitter, link: "#" },
    { icon: FaLinkedinIn, link: "#" },
    { icon: FaInstagram, link: "#" },
    { icon: FaYoutube, link: "#" },
  ];

  // Inject all styles
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .site-footer {
        background: #025261;
        color: #ffffff;
        padding: 52px 20px 26px;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        position: relative;
      }

      .footer-grid {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        max-width: 1300px;
        margin: 0 auto;
        gap: 32px 20px;
      }

      /* ===== Brand column ===== */
      .footer-brand {
        flex: 1 1 280px;
        max-width: 320px;
      }

      .footer-logo {
        filter: brightness(0) invert(1);
        height: 38px;
        margin-bottom: 16px;
      }

      .footer-address-box {
        margin-bottom: 18px;
      }

      .footer-address-title {
        font-size: 12.5px;
        font-weight: 700;
        color: #ebc367;
        letter-spacing: 0.4px;
        display: block;
        margin-bottom: 6px;
      }

      .footer-address-text {
        font-size: 12.5px;
        line-height: 1.6;
        color: #dceef0;
      }

      .footer-contact-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 12px;
        font-size: 13px;
      }

      .footer-contact-row svg {
        color: #ebc367;
        font-size: 14px;
        flex-shrink: 0;
      }

      .footer-contact-row a {
        color: #ffffff;
        text-decoration: none;
      }

      .footer-social-title {
        color: #ebc367;
        font-size: 13px;
        font-weight: 600;
        margin: 24px 0 12px 0;
      }

      .footer-social-row {
        display: flex;
        gap: 10px;
      }

      .social-icon {
        background: rgba(255, 255, 255, 0.1);
        width: 34px;
        height: 34px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        text-decoration: none;
        font-size: 13px;
        transition: all 0.3s ease;
      }

      .social-icon:hover {
        background: #ebc367;
        color: #025261;
        transform: translateY(-3px);
      }

      /* ===== Link columns ===== */
      .footer-col {
        flex: 1 1 150px;
      }

      /* "What We Do" needs two side-by-side sub-columns */
      .footer-col-services {
        flex: 1 1 280px;
        display: flex;
        gap: 24px;
      }

      .footer-col-services .footer-sub-col {
        flex: 1 1 130px;
      }

      .footer-col-title {
        color: #ebc367;
        margin-bottom: 16px;
        font-size: 14.5px;
        font-weight: 700;
        letter-spacing: 0.2px;
      }

      .footer-col ul,
      .footer-sub-col ul {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .footer-col li,
      .footer-sub-col li {
        margin-bottom: 10px;
      }

      .footer-col a,
      .footer-sub-col a {
        color: #dceef0;
        text-decoration: none;
        font-size: 12.5px;
        line-height: 1.4;
        transition: color 0.2s ease;
      }

      .footer-col a:hover,
      .footer-sub-col a:hover {
        color: #ebc367 !important;
      }

      /* ===== Bottom bar ===== */
      .footer-bottom {
        border-top: 1px solid rgba(255, 255, 255, 0.18);
        margin-top: 36px;
        padding-top: 18px;
        text-align: center;
      }

      .footer-bottom-brand {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 11.5px;
        opacity: 0.9;
      }

      .footer-bottom-logo {
        height: 20px;
        object-fit: contain;
        filter: brightness(0) invert(1);
      }

      .footer-bottom-brand strong {
        color: #ebc367;
        font-weight: 600;
        letter-spacing: 0.3px;
      }

      .footer-bottom-links {
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
        font-size: 11px;
        opacity: 0.75;
        flex-wrap: wrap;
      }

      .footer-bottom-links a {
        color: #ffffff;
        text-decoration: none;
      }

      .footer-bottom-links a:hover {
        color: #ebc367;
      }

      /* ===== Responsive footer ===== */
      @media (max-width: 1024px) {
        .footer-grid {
          gap: 28px 18px;
        }
      }

      @media (max-width: 768px) {
        .site-footer {
          padding: 40px 18px 20px;
        }
        .footer-grid {
          flex-direction: column;
          gap: 30px;
        }
        .footer-brand {
          max-width: 100%;
        }
        .footer-col-services {
          gap: 16px;
        }
      }

      @media (max-width: 480px) {
        .footer-col-title {
          font-size: 13.5px;
        }
        .footer-col a,
        .footer-sub-col a {
          font-size: 12px;
        }
        .footer-address-text,
        .footer-contact-row {
          font-size: 12px;
        }
        .footer-col-services {
          gap: 12px;
        }
      }

      /* ===== Chat widget ===== */
      .chat-toggle-btn {
        position: fixed;
        bottom: 30px;
        right: 30px;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: linear-gradient(135deg, #25D366, #128C7E);
        color: #ffffff;
        border: none;
        cursor: pointer;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        z-index: 999;
        transition: all 0.3s ease;
      }

      .chat-toggle-btn:hover {
        transform: scale(1.08);
        box-shadow: 0 6px 25px rgba(0, 0, 0, 0.4);
      }

      .chat-box {
        position: fixed;
        bottom: 96px;
        right: 30px;
        width: 340px;
        max-width: 90vw;
        height: 430px;
        background: #ffffff;
        border-radius: 14px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
        overflow: hidden;
        transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        z-index: 998;
        display: flex;
        flex-direction: column;
        opacity: 0;
        transform: translateY(20px) scale(0.98);
        pointer-events: none;
      }

      .chat-box.open {
        opacity: 1;
        transform: translateY(0) scale(1);
        pointer-events: auto;
      }

      .chat-header {
        background: linear-gradient(135deg, #025261, #013a43);
        color: #ffffff;
        padding: 14px 18px;
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .chat-header-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: #ebc367;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        color: #025261;
        font-size: 15px;
      }

      .chat-header-title {
        font-weight: 700;
        font-size: 14px;
        color: #ffffff;
        white-space: nowrap;
      }

      .chat-header-sub {
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 11px;
        color: #d7ecee;
      }

      .chat-call-bar {
        background: linear-gradient(135deg, #f8f9fa, #e9ecef);
        padding: 10px 18px;
        border-bottom: 1px solid #dee2e6;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        flex-wrap: wrap;
      }

      .chat-call-info {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
      }

      .chat-call-info svg {
        color: #25D366;
        font-size: 15px;
        flex-shrink: 0;
      }

      .chat-call-label {
        font-size: 11px;
        color: #666;
      }

      .chat-call-number {
        color: #025261;
        font-weight: 700;
        text-decoration: none;
        font-size: 12.5px;
      }

      .chat-call-btn {
        background: #25D366;
        color: #ffffff;
        padding: 6px 13px;
        border-radius: 18px;
        text-decoration: none;
        font-size: 11px;
        font-weight: 700;
        display: flex;
        align-items: center;
        gap: 5px;
        white-space: nowrap;
        flex-shrink: 0;
      }

      .chat-messages {
        flex: 1;
        padding: 14px;
        overflow-y: auto;
        background: #f8f9fa;
      }

      .chat-msg-row {
        margin-bottom: 12px;
        display: flex;
        flex-direction: column;
      }

      .chat-msg-row.user {
        align-items: flex-end;
      }

      .chat-msg-row.bot {
        align-items: flex-start;
      }

      .chat-bubble {
        padding: 9px 13px;
        border-radius: 16px;
        max-width: 85%;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
        font-size: 12.5px;
        line-height: 1.45;
        word-break: break-word;
      }

      .chat-bubble.user {
        background: #025261;
        color: #ffffff;
      }

      .chat-bubble.bot {
        background: #ffffff;
        color: #333333;
        border: 1px solid #dee2e6;
      }

      .chat-time {
        font-size: 9.5px;
        color: #888;
        margin-top: 4px;
      }

      .chat-input-area {
        padding: 13px;
        border-top: 1px solid #dee2e6;
        background: #ffffff;
      }

      .chat-input-row {
        display: flex;
        gap: 8px;
        align-items: flex-end;
      }

      .chat-textarea {
        flex: 1;
        padding: 9px 13px;
        border: 1px solid #dee2e6;
        border-radius: 22px;
        resize: none;
        font-family: inherit;
        font-size: 13px;
        min-height: 40px;
        max-height: 100px;
        line-height: 1.4;
        outline: none;
      }

      .chat-textarea:focus {
        border-color: #025261;
      }

      .chat-send-btn {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: none;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.25s ease;
        flex-shrink: 0;
        font-size: 15px;
        cursor: pointer;
      }

      .chat-footer-note {
        font-size: 10px;
        color: #666;
        text-align: center;
        margin-top: 8px;
      }

      .chat-footer-note a {
        color: #25D366;
        text-decoration: none;
        font-weight: 700;
      }

      @media (max-width: 480px) {
        .chat-toggle-btn {
          width: 46px;
          height: 46px;
          bottom: 16px;
          right: 16px;
          font-size: 18px;
        }
        .chat-box {
          right: 5vw;
          left: 5vw;
          width: 90vw;
          bottom: 74px;
          height: 380px;
        }
        a, button, [role="button"] {
          min-height: 40px;
        }
        input, textarea {
          font-size: 16px !important;
        }
      }

      /* Scrollbars */
      *::-webkit-scrollbar { width: 6px; }
      *::-webkit-scrollbar-track { background: #f1f1f1; }
      *::-webkit-scrollbar-thumb { background: #c1c1c1; border-radius: 3px; }
      *::-webkit-scrollbar-thumb:hover { background: #a1a1a1; }
      * { scrollbar-width: thin; scrollbar-color: #c1c1c1 #f1f1f1; }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <>
      {/* Chat Toggle Button */}
      <button className="chat-toggle-btn" onClick={toggleChat} aria-label="Toggle chat">
        {isChatOpen ? <MdClose /> : <FaWhatsapp />}
      </button>

      {/* Chat Box */}
      <div className={`chat-box ${isChatOpen ? "open" : ""}`}>
        {/* Header */}
        <div className="chat-header">
          <div className="chat-header-avatar">
            <MdMessage />
          </div>
          <div>
            <div className="chat-header-title">Envision Support</div>
            <div className="chat-header-sub">
              <BsClock />
              <span>Typically replies in 5 mins</span>
            </div>
          </div>
        </div>

        {/* Call bar */}
        <div className="chat-call-bar">
          <div className="chat-call-info">
            <IoCall />
            <div>
              <div className="chat-call-label">Call us directly</div>
              <a href="tel:+919063906314" className="chat-call-number">
                +91 90639 06314
              </a>
            </div>
          </div>
          <a href="tel:+919063906314" className="chat-call-btn">
            <IoCall /> Call Now
          </a>
        </div>

        {/* Messages */}
        <div className="chat-messages">
          {chatMessages.map((msg) => (
            <div key={msg.id} className={`chat-msg-row ${msg.sender}`}>
              <div className={`chat-bubble ${msg.sender}`}>{msg.text}</div>
              <span className="chat-time">{msg.time}</span>
            </div>
          ))}
        </div>

        {/* Input */}
        <div className="chat-input-area">
          <div className="chat-input-row">
            <textarea
              className="chat-textarea"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Type your message here..."
            />
            <button
              className="chat-send-btn"
              onClick={handleSendMessage}
              disabled={!message.trim()}
              style={{
                background: message.trim() ? "#025261" : "#ccc",
                cursor: message.trim() ? "pointer" : "not-allowed",
              }}
            >
              <IoSend />
            </button>
          </div>
          <div className="chat-footer-note">
            Connect with us on{" "}
            <a href="https://wa.me/919063906314" target="_blank" rel="noopener noreferrer">
              WhatsApp
            </a>{" "}
            for faster response
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="site-footer">
        <div className="footer-grid">
          {/* Brand column */}
          <div className="footer-brand">
            <img src={logo} alt="Envision Integrated Services" className="footer-logo" />

            <div className="footer-address-box">
              <span className="footer-address-title">ENVISION GROUP — HYDERABAD</span>
              <div className="footer-address-text">
                #913, Manjeera Trinity Corporate, 9th Floor,
                <br />
                Office No.913, KPHB, Hyderabad,
                <br />
                Telangana, India - 500085
              </div>

              <div className="footer-contact-row">
                <MdPhone />
                <a href="tel:+919063906314">+91 90639 06314</a>
              </div>
              <div className="footer-contact-row">
                <MdEmail />
                <a href="mailto:info@envision.com">info@envision.com</a>
              </div>
            </div>

            <div>
              <h5 className="footer-social-title">Follow Us</h5>
              <div className="footer-social-row">
                {socialLinks.map(({ icon: Icon, link }, i) => (
                  <a key={i} href={link} className="social-icon">
                    <Icon />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* What We Do — split into two sub-columns */}
          <div className="footer-col-services">
            <div className="footer-sub-col">
              <h4 className="footer-col-title">What We Do</h4>
              <ul>
                {servicesCol1.map((service, index) => (
                  <li key={index}>
                    <Link to={service.path}>{service.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="footer-sub-col">
              <h4 className="footer-col-title">&nbsp;</h4>
              <ul>
                {servicesCol2.map((service, index) => (
                  <li key={index}>
                    <Link to={service.path}>{service.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Industry */}
          <div className="footer-col">
            <h4 className="footer-col-title">Industry</h4>
            <ul>
              {industryLinks.map((item, index) => (
                <li key={index}>
                  <Link to={item.path}>{item.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Product */}
          <div className="footer-col">
            <h4 className="footer-col-title">Product</h4>
            <ul>
              {productsData.map((product, index) => (
                <li key={index}>
                  <Link to={product.path}>{product.name}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-brand">
            <img src={logo} alt="Envision Logo" className="footer-bottom-logo" />
            <span>
              © 2026 <strong>ENVISION INTEGRATED SERVICES</strong>. All Rights Reserved.
            </span>
          </div>

          <div className="footer-bottom-links">
            <Link to="/privacypolicy">Privacy Policy</Link>
            <span style={{ opacity: 0.5 }}>•</span>
            <a
              href="https://www.mappls.com/direction-from-current-location?-to-envision-integrated-services-registered-office?@zdata=ZnJvbSs3OC4zOTI4MzExMDE1ODY4MiUyQzE3LjQ4OTUyOTk0ODMwMTQ1NiUyQyUzQjc4LjM5MjgzMTEwMTU4NjgyJTJDMTcuNDg5NTI5OTQ4MzAxNDU2JTJDK3RvKzc4LjM5MzAwOSUyQzE3LjQ4OTUwMiUyQzg3ZXAzaCUzQjc4LjM5MjkzOSUyQzE3LjQ4OTMzOSUyQzg3ZXAzaCt2K3x8fHx8fHwrZHJpdmluZytJbmRpYUBpbmQrKzA="
              target="_blank"
              rel="noopener noreferrer"
            >
              Sitemap
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;